/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : MIGRATION CONFIRM : STYLES --------------- ++++++++++ */
export default theme =>({
  migrationconfirm: {
    extend: theme.modal.form,
    maxWidth: pxToEm(480),
    padding: `${pxToEm(8)} ${pxToEm(16)}`,
    '& .name-migrationconfirm':{
      '& .bodycopy':{
        marginTop:pxToEm(48),
        marginBottom: pxToEm(24),
        textAlign: 'center'
      }
    },
    '& .name-ctas':{
      marginTop:pxToEm(16)
    },
  }
});
